import React from "react";
import "../styles/NotFound.css";
import notFoundImage from "../assets/404.jpeg"; // put your image here

const NotFound = () => {
  return (
    <div className="notfound-container">
      <img src={notFoundImage} alt="404 Not Found" className="notfound-image" />
    </div>
  );
};

export default NotFound;
